import PropTypes from 'prop-types';
import {DateTime} from 'luxon';


// ------ actions
export const ACTION_TOAST_MESSAGE = 'ACTION_TOAST_MESSAGE';

export const ACTION_TOAST_MESSAGE_REMOVE = 'ACTION_TOAST_MESSAGE_REMOVE';



// ------ common
export const NOTIFICATION_TYPE_ERROR = 'error';
export const NOTIFICATION_TYPE_SUCCESS = 'success';
export const NOTIFICATION_TYPE_WARNING = 'warning';

export const NOTIFICATION_TYPES = [
    NOTIFICATION_TYPE_ERROR,
    NOTIFICATION_TYPE_SUCCESS,
    NOTIFICATION_TYPE_WARNING
];


export const TIMEOUT_DEFAULT_MILLIS = 5000;

export const TIMEOUT_TOAST_MESSAGE_MILLIS = TIMEOUT_DEFAULT_MILLIS;



// ------ shapes base
const SHAPE_MESSAGE_BASE = {
    content: PropTypes.any.isRequired,
    id: PropTypes.string.isRequired,
    postedAt: PropTypes.instanceOf(DateTime).isRequired,
    removeAt: PropTypes.instanceOf(DateTime).isRequired,
    timeout: PropTypes.number.isRequired,
    type: PropTypes.oneOf(NOTIFICATION_TYPES).isRequired
};


// ------ shapes - toast messages
export const SHAPE_TOAST_MESSAGE = {
    ...SHAPE_MESSAGE_BASE
};
